import { useEffect, useState } from 'react';
import { NavBar } from '../../../../../themes/components/Navbar';
import { Sidebar } from '../../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FooterRelatorios } from '../../../components/FooterRelatorios';
import { VscRunAll } from 'react-icons/vsc';
import { AiOutlineClear } from 'react-icons/ai';
import { Button } from '../../../../../themes/components/Button';
import { useRelatorios } from '../../../../../contexts/Relatorios';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../../contexts/Modals';
import { ContainerRelatorio } from '../../../components/VisualizarRelatorio';
import { postGrupoCliente } from '../../../apis/serviceRelatorio';
import { FieldDropdownVer2 } from '../../../../../themes/components/FieldDropdown';
import { grupoCliente } from '../../../interfaces';

export const DSCF208 = () => {
    const history = useHistory();
    const { mostrarInfoOK } = useModals();
    const { loadingRelatorio, urls, setUrls, gerarRelatorio, setLoadingRelatorio, buscarGruposClientes } = useRelatorios();
    const [listaGrupos, setListaGrupos] = useState<grupoCliente[]>();
    const [loadingGrupos, setLoadingGrupos] = useState<boolean>(false);
    const [fieldGrupo, setFieldGrupo] = useState<string>("");
    const [codGrupo, setCodGrupo] = useState<string>("");

    function handleChangeGrupo(event: any, option: any, reason: any) {
        async function getGrupo() {
            await buscarGruposClientes(event.target.value, history)
                .then((res) => {
                    setListaGrupos(res);
                    setLoadingGrupos(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaGrupos([]);
                        console.log(err);
                        setLoadingGrupos(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            if (fieldGrupo !== "") {
                setFieldGrupo("");
            }
            setCodGrupo(event.target.value.trim());
            setLoadingGrupos(true);
            getGrupo();
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            if (cod !== null) {
                setFieldGrupo(cod[0]);
            }
        }

        if (reason === "clear" || (event !== null && String(event.target.value).trim() === "")) {
            handleClearFields();
        }
    }

    function getOptionByCod(cod: string) {
        for (let index = 0; listaGrupos && index < listaGrupos.length; index++) {
            const element = listaGrupos[index];
            if (element.codgre === cod) {
                return element;
            }
        }
        return "";
    }

    useEffect(() => {
        setUrls((prevState) => ({
            ...prevState,
            "DSCF208": ""
        }))
        // component unmount 
        return () => {
            setLoadingRelatorio((prevState) => ({
                ...prevState,
                "DSCF208": false
            }))
        }
    }, []);

    function handleClearFields() {
        setFieldGrupo("");
        setCodGrupo("");
    }

    function solicitarRelatorio() {
        let objParams: any = [];
        if(fieldGrupo !== ""){
            objParams.push({ nome: "CODGRE", valor: fieldGrupo })
            gerarRelatorio("DSCF208", JSON.parse(JSON.stringify(objParams)), history)
        } else if(codGrupo !== ""){
            objParams.push({ nome: "CODGRE", valor: codGrupo })
            gerarRelatorio("DSCF208", JSON.parse(JSON.stringify(objParams)), history)
        }else{
            mostrarInfoOK("Necessário informar um Código de Grupo!");
            setUrls((prevState) => ({
                ...prevState,
                "DSCF208": ""
            }))
        }
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-relatorios">
                    <NavBar />
                    <span className="novo-pedido-title-form">Parâmetros do Relatório</span>
                    <div className="relatorios-campo-busca">
                        <form>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Código do Grupo</label>
                                    <div className="pedido-linha-campo">
                                        <FieldDropdownVer2
                                            id="additens-combobox-search-grupo"
                                            options={listaGrupos || []}
                                            loading={loadingGrupos}
                                            value={getOptionByCod(fieldGrupo)}
                                            select={(option: grupoCliente, value: grupoCliente) => option.codgre === value.codgre}
                                            label={(option: grupoCliente) => option.codgre !== undefined ? option.codgre + " - " + option.nomgre : ""}
                                            onChange={(event, option, reason) => handleChangeGrupo(event, option, reason)}
                                            noOptionsText={"Digite um código ou nome válido"}
                                        />
                                    </div>
                                </div>
                                <div className="form-buttons">
                                    <Button titleText="Gerar relatório" classBtn="" onClick={() => solicitarRelatorio()} >
                                        <VscRunAll color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                    <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                                        <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {loadingRelatorio.DSCF208 === true ?
                        <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                        :
                        urls['DSCF208'] !== "" ?
                            <ContainerRelatorio arquivoUrl={urls['DSCF208']} />
                            : <></>
                    }
                </div>
                <FooterRelatorios funcGerar={() => solicitarRelatorio()} funcImprimir={() => { }} regraGerar={true} regraImprimir={false} />
            </div>
            <Toaster />
        </div>
    )
}